import { object, string } from 'yup';
import { useLocalization } from 'localization';

export const activeDirectorySchema = () => {
  const { t } = useLocalization();

  return object().shape({
    branchId: string().required(t('validation.mixed.required')),
    departmentName: string().required(t('validation.mixed.required')),
    customer: string().required(t('validation.mixed.required')),
    selectedCustomerId: string().required(t('validation.mixed.required')),
  });
};
